var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"leftBottom"}},[_c('div',{staticClass:"lb-title"},[_vm._v("2022年4月残疾人就业出勤情况")]),_c('dv-scroll-board',{staticClass:"lb-content",attrs:{"config":_vm.config}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }